import React from 'react';
import Addlabel from "./components/Addlabel"
import "../src/css/addlabel.scss"
import 'antd/dist/antd.css'; 

function App() {
  return (
    <div className="App">
      <Addlabel></Addlabel>
    </div>
  );
}

export default App;
